import { createSelector } from 'reselect'
import { State } from 'interfaces/state'
import { getUserRewardsReducerStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/cryptoRewards'
import { getItemFromCollection } from 'helpers/normalizeHelpers'
import { CurrencyTicker } from 'components/features/rewards/rewardsPane/types/apiResponses'

export function cryptoWalletCollectionSelector (state: State) {
  return getUserRewardsReducerStateSelector(state).cryptoWallet
}

export const cryptoWalletNotEmptyTickerSelector = createSelector(
  cryptoWalletCollectionSelector,
  (collection) => {

    return collection.allKeys.filter((ticker) => {
      return !collection.byKey[ticker].isEmpty
    })
  }
)

export const createCryptoBalanceSelector = () => createSelector(
  cryptoWalletCollectionSelector,
  (_: State, ticker: CurrencyTicker) => ticker,
  (collection, ticker) => {
    return getItemFromCollection(collection, ticker)
  }
)


